import { LinkTarget } from '@website-builder/model/domain/link/link-target.enum';
import { LinkType } from '@website-builder/model/domain/link/link-type.enum';

export class TbLink {
  url = '';
  target: LinkTarget = LinkTarget.SameTab;
  type: LinkType = LinkType.Page;
  displayedUrl?: string;

  static normalizeInPlace(link: TbLink): TbLink {
    const pureLink = new TbLink();

    link.url = link?.url ?? pureLink.url;
    link.target = link?.target ?? pureLink.target;
    link.type = link?.type ?? pureLink.type;
    link.displayedUrl = link?.displayedUrl ?? pureLink.displayedUrl;

    return link;
  }
}
